import { serverURL } from "@/utils/serverURL";

export type EmailExistsResult =
  | { exists: false }
  | {
      exists: true;
      hasPassword: boolean;
      oauthProviders: string[];
    };

export async function checkEmailExists(email: string): Promise<EmailExistsResult> {
  const res = await fetch(serverURL`/public/auth/email-exists`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });
  if (!res.ok) {
    throw new Error(`email-exists failed: ${res.status}`);
  }
  return (await res.json()) as EmailExistsResult;
}
